interface ClearIconProps {
  width?: number | string;
  height?: number | string;
  className?: string;
}

const ClearIcon = ({ width = 12, height = 12, className }: ClearIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M10.2445 1.75545C7.90345 -0.585151 4.09616 -0.585151 1.75507 1.75545C-0.585022 4.09606 -0.585022 7.90433 1.75507 10.2449C2.92562 11.415 4.46283 11.9997 6.00006 11.9997C7.5373 11.9997 9.074 11.415 10.2445 10.2449C12.5852 7.90435 12.5852 4.09606 10.2445 1.75545ZM8.47571 7.76877C8.67129 7.96436 8.67129 8.28051 8.47571 8.4761C8.37816 8.57364 8.25011 8.62267 8.12204 8.62267C7.99398 8.62267 7.86591 8.57364 7.76836 8.4761L6.00004 6.70726L4.23221 8.47558C4.13417 8.57313 4.0061 8.62216 3.87854 8.62216C3.75049 8.62216 3.62241 8.57313 3.52487 8.47558C3.32928 8.28 3.32928 7.96335 3.52487 7.76826L5.29269 5.99994L3.52437 4.23161C3.32879 4.03603 3.32879 3.71938 3.52437 3.52429C3.71946 3.32871 4.03611 3.32871 4.2317 3.52429L6.00002 5.29261L7.76834 3.52429C7.96392 3.32871 8.28008 3.32871 8.47566 3.52429C8.67125 3.71938 8.67125 4.03603 8.47566 4.23161L6.70734 5.99994L8.47571 7.76877Z"
      fill="currentColor"
    />
  </svg>
);

export default ClearIcon;
